import { useEffect, useState } from 'react';
import { useBrand } from 'utils/context/BrandContext';

const useNotificationNumberTabTitle = () => {
  const [messageCount, setMessageCount] = useState(0);
  const { brandConfig } = useBrand();
  const appName = brandConfig.name === 'memo' ? 'MemoWeb' : 'OffiWeb';

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        clearInterval(intervalId!);
        setMessageCount(0);
        intervalId = null;
        document.title = appName;
      } else if (!intervalId && messageCount > 0) {
        intervalId = setInterval(() => {
          document.title =
            document.title === appName ? `You have ${messageCount} new messages` : appName;
        }, 1000);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId!);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [messageCount, appName]);

  return setMessageCount;
};

export default useNotificationNumberTabTitle;
